import { addLocaleData } from 'react-intl';
import he from 'react-intl/locale-data/he';
import en from 'react-intl/locale-data/en';
import moment from 'moment';

let loaded = false;
const configureLocales = function(locale) {
  if (!loaded) {
    addLocaleData([...en, ...he]);
    loaded = true;
  }
  moment.locale(locale);
};

export { configureLocales };



// WEBPACK FOOTER //
// ./app/javascript/common/locales.js